module.exports = __webpack_public_path__ + "static/ganiyat-2c431e07d94621f4331a6f15939a346e.jpg";